var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComplete = function SvgComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.38 1.698.105.081.127-.042a5.374 5.374 0 0 0 1.09-.531c.132-.08.254-.159.37-.233.183-.116.35-.223.52-.317.271-.151.494-.236.69-.242.18-.006.366.055.574.263.65.65.608 1.488.392 2.303-.076.284-.167.546-.252.792l-.11.321a3.116 3.116 0 0 0-.12.458c-.02.13-.03.295.044.437a8.75 8.75 0 1 1-15.68.25.703.703 0 0 0 .028-.464 2.45 2.45 0 0 0-.166-.453 13.339 13.339 0 0 0-.242-.495A9.073 9.073 0 0 1 .5 3.291c-.154-.37-.26-.74-.25-1.096.01-.341.127-.681.446-1.006.46-.34.822-.435 1.111-.422.296.013.556.14.806.316.125.088.242.183.36.28l.004.004c.113.092.231.19.347.266.116.078.25.15.399.176.16.028.32-.001.47-.1A8.708 8.708 0 0 1 9.032.25c1.025 0 1.738.08 2.377.296.638.215 1.22.571 1.97 1.152Z",
    fill: "url(#complete_svg__a)",
    stroke: "#00990F",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 22H30v-2c0-2.206-1.794-4-4-4s-4 1.794-4 4v2h-.5c-.827 0-1.5.673-1.5 1.5v7c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-7c0-.827-.673-1.5-1.5-1.5Zm-7.167-2A2.67 2.67 0 0 1 26 17.333 2.67 2.67 0 0 1 28.667 20v2h-5.334v-2Zm3.334 7.148v1.519a.667.667 0 1 1-1.334 0v-1.519A1.33 1.33 0 0 1 26 24.667c.735 0 1.333.598 1.333 1.333 0 .491-.27.917-.666 1.148Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "complete_svg__a",
    x1: 3.5,
    y1: 16,
    x2: 18,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BD675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60FFA5"
  })))));
};
export default SvgComplete;